import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { ActivityLogFullModel } from "../models/activity-logs/activity-log-full.model";
import { GetActivityLogsRequestModel } from "../models/activity-logs/activity-log-request.model";
import { PagedResult } from "../models/paged-result.model";
import { ActivityLogFilterOptionsModel } from "../models/activity-logs/activity-log-filter-options.model";

@Injectable({
  providedIn: 'root'
})
export class ActivityLogService {

  constructor(
    private httpClient: HttpClient
  ) {}

  public getActivityLogs(
    request: GetActivityLogsRequestModel
  ): Observable<PagedResult<ActivityLogFullModel>> {
    return this.httpClient.post<PagedResult<ActivityLogFullModel>>(
      Configuration.getApiBaseUrl() + '/activity-log',
      request
    );
  }

  public getActivityLogFilterOptions(
    request: GetActivityLogsRequestModel
  ): Observable<ActivityLogFilterOptionsModel> {
    return this.httpClient.post<ActivityLogFilterOptionsModel>(
      Configuration.getApiBaseUrl() + '/activity-log/filter-options',
      request
    );
  }
}

